import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateUpdateModifiersValidationSchema = () =>
  Yup.object().shape({
    code: Yup.string().required('Code is required'),
    name: Yup.string().required('Name is required')
  });

export default function useModifiersFormik(modifiersData = {}, onSubmit) {
  const formik = useFormik({
    initialValues: {
      code: modifiersData?.code ?? '',
      name: modifiersData?.name ?? ''
    },
    enableReinitialize: true,
    validationSchema: CreateUpdateModifiersValidationSchema,
    onSubmit
  });

  return formik;
}
